// extracted by mini-css-extract-plugin
module.exports = {"card-container":"epKJe","text-wrapper":"_1YHRW","res-img":"_1rKb3","headline":"_23JNq","subheadline":"_3XWxW"};